export default {
    USER: "User",
    EMPLOYEE: "Employee",
    ANY: "Any"
}